import { appCode, appName } from './helpers/utils.helper';

const documentFragment = document.createDocumentFragment();

const manifestLink = document.createElement('link');
manifestLink.rel = 'manifest';
manifestLink.href = `/manifest-${appCode ?? 'admin'}.json`;
documentFragment.appendChild(manifestLink);

const faviconLink = document.createElement('link');
faviconLink.rel = 'shortcut icon';
faviconLink.type = 'image/webp';
faviconLink.href = `/assets/icons/icon-${appCode ?? 'admin'}-48.webp`;
documentFragment.appendChild(faviconLink);

const title = document.createElement('title');
const titleContent = appName(appCode);
title.text = titleContent;
documentFragment.appendChild(title);

const appleTouchIconLink = document.createElement('link');
appleTouchIconLink.rel = 'apple-touch-icon';
appleTouchIconLink.type = 'image/webp';
appleTouchIconLink.href = `/assets/icons/icon-${appCode ?? 'admin'}-192.webp`;
documentFragment.appendChild(appleTouchIconLink);

document.head.appendChild(documentFragment);
